export const TARIFF_BASIC = 'tariff-level-basic';
export const TARIFF_MEDIUM = 'tariff-level-medium';
export const TARIFF_MEDIUM_EXTRA = 'tariff-level-medium-extra';
export const TARIFF_HIGH = 'tariff-level-high';
export const TARIFF_PREMIUM = 'tariff-level-premium';

export const BENEFIT_BASIC = 'benefit-level-basic';
export const BENEFIT_MEDIUM = 'benefit-level-medium';
export const BENEFIT_MEDIUM_EXTRA = 'benefit-level-medium-extra';
export const BENEFIT_HIGH = 'benefit-level-high';
export const BENEFIT_PREMIUM = 'benefit-level-premium';

export const BENEFIT_TWICE_DATA = 'CLAIM_GSM_2XDATA';
export const BENEFIT_5_EURO_BONUS = 'CLAIM_5E_VOICE';
export const APPLICABLE_BENEFITS = [BENEFIT_TWICE_DATA, BENEFIT_5_EURO_BONUS];
export const BENEFITS = new Map([
  [BENEFIT_BASIC, [BENEFIT_TWICE_DATA]],
  [BENEFIT_MEDIUM, [BENEFIT_TWICE_DATA, BENEFIT_5_EURO_BONUS]],
  [BENEFIT_MEDIUM_EXTRA, []],
  [BENEFIT_HIGH, [BENEFIT_TWICE_DATA, BENEFIT_5_EURO_BONUS]],
  [BENEFIT_PREMIUM, [BENEFIT_5_EURO_BONUS]],
]);

export const BENEFIT_1_EURO_BONUS = 'CLAIM_1E_VOICE';
export const BENEFIT_2_EURO_BONUS = 'CLAIM_2E_VOICE';
export const BENEFIT_5_EURO_BONUS_V2 = 'CLAIM_5E_VOICE_V2';
export const BENEFIT_2_GB_BONUS = 'CLAIM_2GB_VOICE';
export const BENEFIT_TWICE_DATA_V2 = 'CLAIM_GSM_2XDATA_V2';
export const APPLICABLE_NEW_BENEFITS = [
  BENEFIT_1_EURO_BONUS,
  BENEFIT_2_EURO_BONUS,
  BENEFIT_5_EURO_BONUS_V2,
  BENEFIT_2_GB_BONUS,
  BENEFIT_TWICE_DATA_V2,
];
export const BENEFITS_NEW = new Map([
  [BENEFIT_BASIC, [BENEFIT_1_EURO_BONUS, BENEFIT_2_GB_BONUS]],
  [BENEFIT_MEDIUM, [BENEFIT_2_EURO_BONUS, BENEFIT_TWICE_DATA_V2]],
  [BENEFIT_MEDIUM_EXTRA, [BENEFIT_2_EURO_BONUS, BENEFIT_TWICE_DATA_V2]],
  [BENEFIT_HIGH, [BENEFIT_5_EURO_BONUS_V2, BENEFIT_TWICE_DATA_V2]],
  [BENEFIT_PREMIUM, [BENEFIT_5_EURO_BONUS_V2]],
]);

export const TARIFFS_TO_BENEFITS = {
  [TARIFF_BASIC]: BENEFIT_BASIC,
  [TARIFF_MEDIUM]: BENEFIT_MEDIUM,
  [TARIFF_MEDIUM_EXTRA]: BENEFIT_MEDIUM_EXTRA,
  [TARIFF_HIGH]: BENEFIT_HIGH,
  [TARIFF_PREMIUM]: BENEFIT_PREMIUM,
};

export const BENEFIT_STATUS_APPLIED = 'APPLIED';
export const BENEFIT_STATUS_APPLIED_PROTECTION = 'APPLIED_PROTECTION';
export const BENEFIT_STATUS_WAITING_FOR_FIRST_BD = 'WAITING_FOR_FIRST_BD';
export const ACTIVE_BENEFIT_STATUSES = [
  BENEFIT_STATUS_APPLIED,
  BENEFIT_STATUS_APPLIED_PROTECTION,
  BENEFIT_STATUS_WAITING_FOR_FIRST_BD,
];
export const CONVERGENT_GROUP_FLAG_LOVE = 'L';
export const CONVERGENT_GROUP_FLAG_BASIC = 'B';
export const CONVERGENT_GROUP_TYPE_17 = '17';

export const STATUS_ACTIVE_FROM_BILL_DAY = 'WAITING_FOR_FIRST_BD';
export const STATUS_ACTIVE_TILL_BILL_DAY = 'WAITING_FOR_LAST_BD';
export const STATUS_PROTECTION_PERIOD = 'PROTECTION_PERIOD';
